import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

/**
 * Polymorphic component for rendering paragraphs.
 *
 * @deprecated This component is deprecated and will be removed in a future version.
 * Please use standard HTML elements with Bootstrap classes instead.
 * See the interface documentation above for migration examples.
 */ const Paragraph = ({ as: Component = 'p', small, strong, strikeThrough, underline, inline, className, ...rest })=>{
    // Show deprecation warning in development
    if (process.env.NODE_ENV === 'development') {
        console.warn('⚠️  Paragraph component is deprecated and will be removed in a future version.\n' + 'Please migrate to using standard HTML elements with Bootstrap classes.\n' + 'See the component documentation for migration examples:\n' + '• small → className="small"\n' + '• strong → className="strong"\n' + '• underline → className="text-decoration-underline"\n' + '• strikeThrough → className="text-decoration-line-through"\n' + '• inline → className="m-0" (or use <span> element)');
    }
    return jsx(Component, {
        className: classNames('p', {
            small,
            strong,
            underline,
            'strike-through': strikeThrough,
            'm-0': inline
        }, className),
        ...rest
    });
};

export { Paragraph };
